module.exports = __webpack_public_path__ + "static/media/Assets-08-Visualising-epilepsy-02.c1632da4.png";